import { Link } from "react-router-dom";
import { ArrowUpLeft } from "lucide-react";
import { LOGO_URL } from "@/lib/site";

export default function LegalLayout({ eyebrow, title, children }) {
  return (
    <div className="bg-[#FAFAF7] min-h-screen">
      <header className="border-b border-black/5">
        <div className="mx-auto max-w-[1440px] px-5 md:px-10 h-20 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3" data-testid="legal-back-home">
            <img src={LOGO_URL} alt="Hudak Enterprises" className="h-10 w-auto" />
          </Link>
          <Link to="/" className="btn-ghost">
            <ArrowUpLeft size={16} /> Zurück zur Startseite
          </Link>
        </div>
      </header>

      <main className="mx-auto max-w-[1000px] px-5 md:px-10 py-16 md:py-28">
        <div className="flex items-center gap-4 mb-8">
          <span className="gold-hairline w-10" />
          <span className="chapter-num">{eyebrow}</span>
        </div>
        <h1 className="font-serif-editorial text-5xl md:text-7xl leading-[0.95] tracking-tight mb-14">{title}</h1>
        <div className="legal-prose text-[#0A0A0A]/80 leading-relaxed space-y-8">
          {children}
        </div>
        <div className="mt-20 pt-10 border-t border-black/10 flex flex-col md:flex-row md:items-center md:justify-between gap-4">
          <p className="font-serif-editorial text-2xl italic">Fragen? Wir sind für Sie da.</p>
          <Link to="/#kontakt" className="btn-primary">Kontakt aufnehmen</Link>
        </div>
      </main>
    </div>
  );
}
